<mat-icon class="close-icon" mat-dialog-close>close</mat-icon>
<h4 mat-dialog-title>Search Options</h4>
<mat-dialog-content>
  <div class="table-responsive">
    <table mat-table [dataSource]="searchData">
      <ng-container matColumnDef="example">
        <th mat-header-cell *matHeaderCellDef class="search-example search-table-header">
          Example
        </th>
        <td mat-cell *matCellDef="let element" class="search-example">
          {{ element.example }}
        </td>
      </ng-container>
      <ng-container matColumnDef="result">
        <th mat-header-cell *matHeaderCellDef class="search-result search-table-header">
          Result
        </th>
        <td mat-cell *matCellDef="let element" class="search-result">
          {{ element.result }}
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="columns" class="search-row"></tr>
      <tr mat-row *matRowDef="let row; columns: columns" class="search-row"></tr>
    </table>
  </div>
</mat-dialog-content>